import { DocumentIcon } from '@heroicons/react/24/outline';
import type { AttachmentListProps } from './attachmentList.types';

export function AttachmentList({ attachments }: AttachmentListProps) {
    if (attachments.length === 0) return null;

    return (
        <ul className="mt-2 flex flex-wrap gap-2">
            {attachments.map(attachment => (
                <li key={attachment.path}>
                    <a
                        href={attachment.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="inline-flex max-w-full items-center gap-1.5 rounded-lg border border-raro-gray-200 bg-white px-2.5 py-1 text-xs font-medium text-primary-700 transition hover:border-primary-200 hover:bg-primary-50"
                    >
                        <DocumentIcon className="h-3.5 w-3.5 shrink-0" aria-hidden="true" />
                        <span className="truncate">{attachment.name}</span>
                    </a>
                </li>
            ))}
        </ul>
    );
}
